import { PALETTE, SIZES, MQ_TABLET} from '../../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
const blue = '#13223b';

export default MediaQueryStyleSheet.create({

   TextInput:{
    height: 40, 
    borderColor: 'grey', 
    borderWidth: 1,
    borderRadius:4,
    marginBottom:5,
    color: PALETTE.primaryText,
    flex:1,
   },

  //  MultiLineTextInput :{ 
  //   height: 40, 
  //   borderColor: 'grey', 
  //   borderWidth: 1,
  //   borderRadius:4,
  //   marginBottom:5,
  //   paddingHorizontal: 10,
  //   color: PALETTE.primaryText,
  //   flex:1,
  //   backgroundColor: 'yellow'
  // },
  MultiLineTextInput: {
    height: 30, 
    borderColor: 'gray', 
    borderWidth: 1,
    borderRadius:4,
    marginBottom:5,
    width:355,
    paddingHorizontal: 10,
    color: PALETTE.primaryText,
    flex:1,
    backgroundColor: blue
   },

   RowBottom:{
    marginBottom:5,
    marginTop:10
   },

   root:{
    paddingVertical: 5
   },
   asteriskStyle:{
      color:PALETTE.primaryActive,
      // verticalAlign:'super'
    }
});


